<template>
  <div class="mainBloc">
    <v-container :class="{'py-0 px-12': $vuetify.breakpoint.width > 600}">
      <FilterAnalysisTypes
        :analysisTypes="analysisTypes"
        @filter="selectedAnalysisTypes = $event"
      />
    </v-container>

    <AnalysisType
      v-for="analysisType in selectedAnalysisTypes"
      :key="analysisType.ref"
      :analysis="analysisView[analysisType.ref]"
      :site="workOrder.site"
      :nodes="nodes"
      :analysisType="analysisType"
      :analyses="analyses"
      :isCompletedOrLocked="isCompletedOrLocked"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FilterAnalysisTypes from '@/views/workOrders/FilterAnalysisTypes.vue';
import AnalysisType from '@/components/services/AnalysisType.vue';
import completionStatus from '@/constants/workOrderStatusChoices';


export default {
    components: {
        FilterAnalysisTypes,
        AnalysisType,
    },
    props: {
        analyses: {
            type: Object,
            default: () => ({}),
        },
        nodes: {
            type: [Object, Array],
            default: () => ({}),
        },
    },
    data() {
        return {
            selectedAnalysisTypes: [],
        };
    },
    computed: {
        ...mapGetters([
            'workOrder',
            'analysisView',
            'userLang',
        ]),
        analysisTypes() {
            const analysisTypes = Object.values(this.analysisView)
                .map(analysis => analysis.analysisType)
                .sort((a, b) => a.displayOrder - b.displayOrder);

            return analysisTypes;
        },
        isCompletedOrLocked() {
            return this.workOrder.completionStatus === completionStatus.COMPLETED || !!this.workOrder?.lockData?.isLocked;
        },
    },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 600px) {
  .mainBloc {
    width: 100% !important
  }
}
</style>
